import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, " Справочник необходим для расшифровки текстовых примечаний к заказам, определяющим требования по длине доски в заказе. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pt-2" }, " При импорте заказов, если не удалось расшифровать текстовое примечание, производится его поиск по справочнику. Все ограничения подставляются в номенклатуру заказа. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: Примечания к заказам",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }, 512))
}